<template>
	<body>
	<div id="wrapper">
		<header>
			<div class="header_logo_top">
				<h1><a href="/"><img :src="$t('logo_oures.path')" :alt="$t('logo_oures.alt')" :class="imgClass"></a></h1>
			</div>
			<div class="header_language">
				<a href="#" @click.prevent="change_locale">{{ $t('change_locale') }}</a>
			</div>
		</header>
		<main>
		<div class="main_wrapper">
			<div id="search_ttl">
				<h2><img src="image/title.svg" alt="Find Researchers.研究者を検索する"></h2>
				<!--
				<h3>全{{ count }}名の研究者が登録されています</h3>
				-->
			</div>
			<div>
				<form method="get" @submit.prevent="search_by_keyword" class="search_container">
					<input type="text" size="25" :placeholder="$t('search_by_keyword')" class="search_container_txt" v-model="keyword">
					<input type="image" src="image/icon_search_circle.svg" onMouseOver="this.src='image/icon_search_circle_on.svg'"  onmouseout="this.src='image/icon_search_circle.svg'" alt="検索" class="search_container_img">
				</form>
				<div class="search_post_area">
						<HowToUse />
						<ul class="keyword_boolean_list right-side">
							<li class="keyword_boolean" :class="{ 'btn_check': operator === 'AND' }" @click="operator = 'AND'">{{ $t('and_search') }}</li>
							<li class="keyword_boolean" :class="{ 'btn_check': operator === 'OR' }" @click="operator = 'OR'">{{ $t('or_search') }}</li>
						</ul>
				</div>
			</div>


			<div>
				<form method="get" @submit.prevent="search_by_name" class="search_container search_double">
					<input type="text" size="225" :placeholder="$t('search_by_name')" class="search_container_txt" v-model="name">
					<input type="image" src="image/icon_search_circle.svg" onMouseOver="this.src='image/icon_search_circle_on.svg'"  onmouseout="this.src='image/icon_search_circle.svg'" alt="検索" class="search_container_img">
				</form>
			</div>
			<div id="search_double">
<!--所属で検索-->
				<div class="search_spfield accordion_big">
					<div class="search_spfield_ttl button_big">{{ $t('search_by_department') }}</div>
					<div class="division_contener nest_big">
						<div class="scroll_bar">
							<ul>
								<li class="accordion" v-for="o1 in organizations" :key="o1.key">
									<div class="division_list button">
										<div @click.prevent="search_by('org_lv1', o1.code)">{{ o1[lang] }}</div>
									</div>
									<div class="division_list_in nest">
										<ul>
											<a href="#" @click.prevent="search_by('org_lv2', o2.code)" v-for="o2 in o1.items" :key="o2.code"><li>{{ o2[lang] }}</li></a>
										</ul>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>

<!--専門分野で検索-->
				<div class="search_spfield accordion_big">
					<div class="search_spfield_ttl button_big">{{ $t('search_by_field') }}</div>
					<div class="division_contener nest_big">
						<div class="scroll_bar">
							<ul>
								<li class="accordion" v-for="discipline in research_areas" :key="discipline.code">
									<div class="division_list button">
										<a href="#" @click.prevent="search_by('area_lv1', discipline.code)">{{ discipline[lang] }}</a>
									</div>
									<div class="division_list_in nest">
										<ul>
											<a href="#" @click.prevent="search_by('area_lv2', field.code)" v-for="field in discipline.items" :key="field.code"><li>{{ field[lang] }}</li></a>
										</ul>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>

				</div>
			</div>
		</main>
		<footer>
			<p class="footer_img"><img src="image/img_ou_hall.png"></p>
			<p class="footer_copy">
				<a href="https://www.osaka-u.ac.jp/ja" target="_blank"><img src="image/logo_ou.svg" align="left" alt="大阪大学"></a>
				(C) The University of Osaka.
			</p>
		</footer>
	</div>
	</body>
</template>

<script>
import config from '../config'
import axios from 'axios'
import HowToUse from "./HowToUse.vue";

export default {
  name: 'top',
  components: {HowToUse,},
  data() {
	  return {
		  count: 0,
		  keyword: '',
		  name: '',
		  research_areas: [],
		  organizations: [],
		  operator: 'AND', // 初期状態でANDを選択
	  }
  },
  created() {

	switch (this.$route.query.lang) {
		case 'ja':
		case 'en':
			this.$store.commit('save_lang', this.$route.query.lang);
			location.href = '/';
			return;
	}

	this.$i18n.locale = this.$store.state.lang;
	
	axios.get(config.WEB_HOST + '/count.txt')
		.then((response) => {
			this.count = response.data;
		});
	
	axios.get(config.WEB_HOST + '/master/research_areas.json')
		.then((response) => {
			this.research_areas = response.data;
		});

	axios.get(config.WEB_HOST + '/master/organizations.json')
		.then((response) => {
			this.organizations = response.data;
		});
  },
  mounted() {
    $(function() {
		$(".accordion .nest").hide();
		$(".accordion .button").on("click", function() {
			$(this).next().slideToggle();
			$(this).toggleClass("active");
		});

		$(".accordion_big .nest_big").hide();
		$(".accordion_big .button_big").on("click", function() {
			$(this).next().slideToggle();
			$(this).toggleClass("active");
		});
	});
  },
  methods: {
	change_locale() {
		this.$emit('change-locale')
	},
    search_by_keyword() {
		this.$store.commit('init_query');
		this.$store.commit('save_query', {'keyword': this.keyword,'operator':this.operator});
		this.$router.push({name: 'list', query: {}})
	},
	search_by_name() {
		this.$store.commit('init_query');
		this.$store.commit('save_query', {'name': this.name,'operator':'AND'});
		this.$router.push({name: 'list', query: {}})
	},
	search_by(name, value) {
		this.$store.commit('init_query');
		const params = {'operator':'AND'};
		params[name] = value;
		this.$store.commit('save_query', params);
		this.$router.push({name: 'list', query: {}});
	}
  },
  computed: {
	lang: function() {
		return this.$i18n.locale;
	},
	imgClass() {
      return `img_${this.lang}`;
    }
  }
}
</script>

<style scoped>
/* top.css */

@charset "utf-8";
/*Common css*/



/*  Layout
======================================== */

body {
	color: #fff;
	font-size: 1rem;
	font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", Hiragino Kaku Gothic ProN, Arial, "メイリオ", Meiryo, sans-serif;
	background: -moz-radial-gradient(#2D287F, #1A174E); 
	background: -webkit-radial-gradient(#2D287F, #1A174E); 
	background: radial-gradient(#2D287F, #1A174E); 
}

#wrapper{
	height: 100vh;
	min-height: 100vh;
	display:-webkit-box;
  	display:-ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
  	-webkit-box-direction: normal;
  	-ms-flex-direction: column;
	flex-direction: column;
}

@media screen and (min-width: 1980px) {
	#wrapper{
	background-size: 1350px; 
	}
}
@media screen and (max-width: 480px) {
	#wrapper{
	background-size: 100%; 
	}
}

/* header
======================================== */

header {
	display:-webkit-box;
  	display:-ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	padding: 15px 20px;
}

.header_logo_top h1 .img_ja{
	width: 250px;
	height: auto;
	color: #fff;
}

.header_logo_top h1 .img_en{
	width: 300px;
	height: auto;
	color: #fff;
}

.header_logo_top h1 a:hover img{
  opacity: 0.7;
  filter: alpha(opacity=80);
  -moz-opacity: 0.5;
  -webkit-transition: 0.2s ease-in-out;
  -moz-transition: 0.2s ease-in-out;
  -o-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}

.header_language a{
	font-weight: 600;
	text-decoration:none;
	color:#FFFFFF;
	-webkit-transition: 0.2s ease-in-out;
	-moz-transition: 0.2s ease-in-out;
	-o-transition: 0.2s ease-in-out;
	transition: 0.2s ease-in-out;
}

.header_language a:hover{
	opacity: 0.7 ;
}

@media screen and (max-width: 480px) {
	header {
			padding: 15px 10px;
		}
	.header_logo_top h1 .img_ja{
		width: 200px;
		height: auto;
	}

	.header_logo_top h1 .img_en{
		width: 300px;
		height: auto;
	}
}

/* main
======================================== */

main{
/*	height: 100vh;*/
	display:-webkit-box;
  	display:-ms-flexbox;
	display: flex;
	-webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
	align-items: center;
	justify-content: center;
}

.main_wrapper{
	z-index: 100;
	margin-top: 150px;
	margin-bottom: 100px;
}

@media screen and (max-width: 1600px) {
	.main_wrapper{
		width: 70%;
		max-width:600px;
		margin-top: 80px;
	}
}

@media screen and (max-width: 480px) {
	.main_wrapper{
		width: 80%;
	}
}


/*  search_ttl
-------------------- */

#search_ttl{
	text-align: left;
	width: 100%;
}

#search_ttl h2 img{
	width: 900px;
	padding: 0;
	margin: 0;
}

#search_ttl h3{
	font-weight:500;
	margin:50px 0 0;
	font-size: 1.2rem;
}


/*1360以下*/
@media screen and (max-width: 1600px) {
	#search_ttl h2 img{
		margin: 0 auto;
		width: 100%;
		max-width: 600px;
	}
	#search_ttl h3{
		font-size: 0.9rem;
		margin:50px 0 0px;
		font-weight: 500;
	}
}


@media screen and (max-width: 480px) {
	#search_ttl h3{
		font-size: 0.9rem;
		margin:30px 0 0px;
		font-weight: 500;
	}
}



/* footer
======================================== */

footer {
 	margin-top: auto;
	display:-webkit-box;
  	display:-ms-flexbox;
	display: flex;
	text-align: left;
	position:relative;
}

.footer_img{
	position:absolute;
	bottom: 0;
	left: 0;
	width: 100%;
}

.footer_img img{
	width: 90%;
	max-width: 1150px;
}


@media screen and (max-width: 1370px) {
	.footer_img img{
		max-width: 750px;
	}
}

@media screen and (max-width: 480px) {
	.footer_img img{
		width: 100%;
	}
}


.footer_copy{
	position:absolute;
	bottom: 5px;
	left:20px;
	font-size: 0.7rem;
/*	padding: 0 20px 5px;*/
	color: #fff;
}

.footer_copy img{
	width: 25px;
	height: auto;
	padding-right: 10px;
	padding-bottom: 5px;
}

.footer_copy a:hover img{
  opacity: 0.7;
  filter: alpha(opacity=80);
  -moz-opacity: 0.5;
  -webkit-transition: 0.2s ease-in-out;
  -moz-transition: 0.2s ease-in-out;
  -o-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}


@media screen and (max-width: 480px) {
#footer_copy{ 
	padding: 0 10px 5px;
	}
}

</style>